import Vue from "vue"
import Router from "vue-router"

import WagtailPageHandler from "./views/WagtailPageHandler.vue"
import DemoBuilder from "./views/DemoBuilder.vue"

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '/demo-builder', component: DemoBuilder, },
    { path: '*', component: WagtailPageHandler, },
  ],
})